import { render, staticRenderFns } from "./Aboutus.vue?vue&type=template&id=f156d30c&scoped=true"
import script from "./Aboutus.vue?vue&type=script&lang=js"
export * from "./Aboutus.vue?vue&type=script&lang=js"
import style0 from "./Aboutus.vue?vue&type=style&index=0&id=f156d30c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f156d30c",
  null
  
)

export default component.exports